import type { IconName } from '@cencosud-cencommerce/paris-uikit';

import type { DeliveryDateItemProps } from '@/Application/Components/DeliveryDateSelect/DeliveryDateItem/DeliveryDateItem';
import type { Address } from '@/modules/address/domain/Address';
import type {
  ClassificationGroupMetaDto,
  DeliveryProduct,
  PickupOption,
  TimeSlotValue
} from '@/modules/shippingMethod/domain/ShippingMethod';
import type {
  GeneralDeliveryShippingOptionDto,
  HttpClientPreferenceParams
} from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

export enum ESellerType {
  '1P' = '1P',
  '3P' = '3P'
}

export interface DeliveryCardProps {
  id: string;
  productList?: DeliveryProduct[];
  iconName: IconName;
  title: string;
  saleTagLabel?: string;
  saleTagStoreName?: string;
  sellerType?: string;
  intangible?: boolean;
  pickupOptions?: PickupOption[];
  shippingOptions?: DeliveryDateItemProps[];
  scheduledOptions?: GeneralDeliveryShippingOptionDto[];
  cartShippingAddress?: Address;
  groupNumber?: number;
  classificationGroupMeta?: ClassificationGroupMetaDto;
  setSelectShippingMethod: ({
    id,
    isPickup,
    deliveryGroupId
  }: {
    id: string;
    isPickup: boolean;
    deliveryGroupId: string;
  }) => void;
  handleSetOptions: () => void;
  handleSelectClientOption: (
    deliveryGroupId: string,
    param?: HttpClientPreferenceParams,
    date?: string
  ) => void;
  setOtherError: (value: boolean) => void;
}

export interface TimeFrame extends TimeSlotValue {
  isInitialTimeFrame: boolean;
  id: string;
}
